import { Scenes } from "../types";
import { SceneBackgroundData } from "./types";
import { IMAGES, VIDEOS } from "./video";

export default Object.freeze({
	SPLASH_SCREEN: {
		videoName: "splash-screen-video",
		src: VIDEOS.SPLASH_SCREEN,
	},
	CABIN_HUB: {
		videoName: "hub-video",
		src: VIDEOS.CABIN_HUB,
	},
	CABIN_CAT: {
		videoName: "cabin-cat-video",
		src: VIDEOS.CAT,
	},
	CABIN_COUCH: {
		videoName: "cabin-couch-video",
		src: VIDEOS.COUCH,
	},
	CABIN_RADIO: {
		videoName: "cabin-game-table-video",
		src: VIDEOS.RADIO,
	},
	CABIN_GAME_TABLE: {
		videoName: "cabin-game-table-image",
		src: IMAGES.GAME_TABLE,
	},
	CABIN_FIREPLACE: {
		videoName: "cabin-fireplace-video",
		src: VIDEOS.FIREPLACE,
	},
	CABIN_WINDOW: {
		videoName: "cabin-window-video",
		src: VIDEOS.WINDOW,
	},
	CABIN_LIBRARY: {
		videoName: "cabin-library-video",
		src: VIDEOS.BOOKSHELF,
	},
	CABIN_DESK: {
		videoName: "cabin-desk-image",
		src: VIDEOS.DESK,
	},
	CABIN_DESK_DRAWER: {
		videoName: "cabin-desk-drawer-image",
		src: IMAGES.DESK_DRAWER,
	},
	CABIN_EXIT: {
		videoName: "cabin-exit-image",
		src: IMAGES.CABIN_EXIT,
	},
	CABIN_KITCHEN: {
		videoName: "cabin-kitchen-image",
		src: IMAGES.CABIN_KITCHEN,
	},
	PLANE: {
		videoName: "plane",
		src: VIDEOS.PLANE,
	},
	PLANE_RETURN: {
		videoName: "plane-return",
		src: VIDEOS.PLANE_RETURN,
	},
	CABANA: {
		videoName: "cabana",
		src: VIDEOS.CABANA,
	},
	CABANA_BEACH: {
		videoName: "cabana-beach",
		src: VIDEOS.CABANA_BEACH,
	},
	INTERACTIVE_CAT: {
		videoName: "interactive-cat",
		src: VIDEOS.CAT,
	},
}) satisfies Record<Scenes, SceneBackgroundData>;
